// extracted by mini-css-extract-plugin
export default {"container":"reset-password_container__+03x0","form":"reset-password_form__Qpz47","actions":"reset-password_actions__BFQkw","actions__link":"reset-password_actions__link__74R85"};